import { createSubmission } from '@wix/auto_sdk_forms_submissions';

const INQUIRY_FORM_ID = '2b9d5298-0e64-47e6-9d40-499119388aa4';

async function submitInquiry(payload) {
  const submission = {
    formId: INQUIRY_FORM_ID,
    status: 'PENDING',
    seen: false,
    submissions: {
      name: payload.name,
      email: payload.email,
      organization: payload.organization || '',
      interest: payload.interest,
      situation: payload.situation
    }
  };

  const result = await createSubmission(submission);

  // createSubmission() resolves to the submission itself, not { submission }.
  // The old check looked for result.submission._id, which could never be true —
  // so a submission that saved correctly still showed the visitor an error.
  // Both shapes are accepted here in case the SDK response shape changes.
  return {
    ok: Boolean(result && (result._id || (result.submission && result.submission._id)))
  };
}

window.sfpWixForms = Object.freeze({ submitInquiry });
document.documentElement.dataset.sfpInquiryAdapter = 'ready';
